import axios from "axios";
import { toastr } from "react-redux-toastr";

import config from "../../config/constants";
import {
  getImportStatus,
  loadProcessToken,
  showErrorToaster
} from "./index";
import {loadFeatureImageAPI} from "./reportAction";
import {SET_ASSET_PREDICTION_FILTER_FIELD_DATA_QUERY} from "./eventManagement";
import {LOAD_LABEL_MANAGER} from "./feedbackActions";

export const LOAD_COMPONENTS = 'LOAD_COMPONENTS';
export const LOAD_COMPONENT_PAGES = 'LOAD_COMPONENT_PAGES';
export const CREATE_COMPONENT = 'CREATE_COMPONENT';
export const UPDATE_COMPONENT = 'UPDATE_COMPONENT';
export const DELETE_COMPONENT = 'DELETE_COMPONENT';
export const OPEN_COMPONENT = 'OPEN_COMPONENT';
export const COMPONENT_IMPORT_STATUS = 'COMPONENT_IMPORT_STATUS';
export const LOAD_COMPONENT_TYPE = 'LOAD_COMPONENT_TYPE';
export const LOAD_COMPONENT_HISTORY = 'LOAD_COMPONENT_HISTORY';
export const SET_ASSET_HEALTH_FILTER_FIELD_DATA_QUERY = 'SET_ASSET_HEALTH_FILTER_FIELD_DATA_QUERY';
export const LOADING_COMPONENTS = 'LOADING_COMPONENTS';


export const loadComponents = (props, scope) => (dispatch, getState) => {
  let token = loadProcessToken();

  let queryString = null;
  let url = null;

  if(props) {
        if (props.asset_name){
            if (queryString ==null){
                queryString =  '?' + 'asset_name=' + props.asset_name;
            } else{
                queryString =  queryString + '&' + 'asset_name=' + props.asset_name;
            }
        }
        if (props.parent_asset_id){
            if (queryString ==null){
                queryString =  '?' + 'parent_asset_id=' + props.parent_asset_id;
            } else{
                queryString =  queryString + '&' + 'parent_asset_id=' + props.parent_asset_id;
            }
        }
  }

  if (queryString ==null){
        url =config.API_URL + 'ai4ai/entities/component';
  } else {
        url = config.API_URL + 'ai4ai/entities/component' + queryString
  }

  axios.get(url).then(({ data }) => {
    if (data){
      dispatch({
        type: LOAD_COMPONENTS,
        payload: data.data
      });
    }
  }).catch(function (error) {
    showErrorToaster(error, "Unknown Error in retrieving component", "Please refer the console logs for more details on the error.");
  });
};



export const loadComponentHistory = (props, scope) => (dispatch, getState) => {
  let token = loadProcessToken();

  let url =config.API_URL + 'ai4ai/entities/history/component/'+props.component_id;
  axios.get(url).then(({ data }) => {
    if (data){
      dispatch({
          type: LOAD_LABEL_MANAGER,
          payload: data.label_manager
      });
      dispatch({
        type: LOAD_COMPONENT_HISTORY,
        payload: data
      });
      loadFeatureImageAPI(data, data.last_location, dispatch);
    }
  }).catch(function (error) {
        showErrorToaster(error, "Unknown Error in retrieving component history data", "Please refer the console logs for more details on the error.");
  });

};

const setAssetHealthFilterFieldDataQuery = payload => ({
  type: SET_ASSET_HEALTH_FILTER_FIELD_DATA_QUERY,
  payload
});

export const loadComponentsByPage = (props, scope) => (dispatch, getState) => {
  const token = loadProcessToken();
  const page = props && props.page ? props.page :1;
  const perPage = props && props.perPage ? props.perPage : 20;
  const filterFieldData =props && props.filterFieldData ? props.filterFieldData.trim() : '';
  const sortBy = props && props.sortBy ? props.sortBy : '';
  const include_pending_count = props && props.includePendingCcount ? props.includePendingCcount : 0;
  const paginationType = props && props.paginationType ? props.paginationType : 'infiniteScroll';

  let queryString = null;
  let url = config.API_URL + 'ai4ai/entities/component?page=' + page + '&per_page=' + perPage + filterFieldData +
      ( sortBy && sortBy.length > 0 ? '&sort_by=' + sortBy : '' ) +
      ( include_pending_count> 0 ? '&include_pending_count=' + include_pending_count : '' );

  axios.get(url).then(({ data }) => {
    if (data){
      data.paginationType = paginationType;
      dispatch({
        type: LOAD_COMPONENT_PAGES,
        payload: data
      });
      dispatch(setAssetHealthFilterFieldDataQuery(filterFieldData));
    }
  }).catch(function (error) {
    showErrorToaster(error, "Unknown Error in retrieving component", "Please refer the console logs for more details on the error.");
  });

};


export const createOrUpdateComponent = (props, history) => (dispatch, getState) => {
  console.log("ACTION props: ", props);
  let token = loadProcessToken();
  if(props._id) {
    axios.put(config.API_URL + 'ai4ai/entities/component', props)
      .then(({ data }) => {
        dispatch({
          type: UPDATE_COMPONENT,
          payload: data.data
        });
        history.push('/settings/create_update_asset_management');
        toastr.success('Successfully update the Component');
      }).catch(function (error) {
      showErrorToaster(error, "Unknown Error in updating component", "Please refer the console logs for more details on the error.");
    });
  } else {
    return axios.post(config.API_URL + 'ai4ai/entities/component', props)
      .then(({ data }) => {
        console.log({data});
        dispatch({
          type: CREATE_COMPONENT,
          payload: data.data
        });
        history.push('/settings/create_update_asset_management');
        toastr.success('Successfully created the Component');
      }).catch(function (error) {
        showErrorToaster(error, "Unknown Error in creating component", "Please refer the console logs for more details on the error.");
      });
  }
};

export const deleteComponent = (props, scope) => (dispatch, getState) => {
  let token = loadProcessToken();
  return axios.delete(config.API_URL + 'ai4ai/entities/component/' + props._id)
    .then(({ data }) => {
      dispatch({
        type: DELETE_COMPONENT,
        payload: props._id
      });
      toastr.success('Successfully deleted the component');
    }).catch(function (error) {
      showErrorToaster(error, "Unknown Error in deleting component", "Please refer the console logs for more details on the error.");
    });
};


export const openComponent = (props, scope) => (dispatch, getState) => {
  dispatch({
    type: OPEN_COMPONENT,
    payload: props
  });
};

export const onComponentImport = (props, scope) => (dispatch, getState) => {
  const token = loadProcessToken();
  let formData = new FormData();
  formData.append('data_file', props.file);

  axios.post(
    config.API_URL + 'ai4ai/entities/bulk_import/component',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  ).then(response => {
    response = response.data;
    if (response){
      localStorage.setItem('fetchImportStatus', true);
      dispatch(getImportStatus(response.data._id, COMPONENT_IMPORT_STATUS));
    }
  }).catch(function (error) {
    showErrorToaster(error, "Unknown Error in importing assets", "Please refer the console logs for more details on the error.");
  });
};

export const stopFetchingImportComponentStatus = () => (dispatch, getState) => {
  localStorage.removeItem('fetchImportStatus');
};

export const deleteComponentImportStatus = () => (dispatch, getState) => {
  dispatch({
    type: COMPONENT_IMPORT_STATUS,
    payload: {},
  });
};

export const loadComponentType = (props, scope) => (dispatch, getState) => {
  let token = loadProcessToken();
  axios.get(config.API_URL + 'ai4ai/types/component').then(({ data }) => {
    if (data){
      dispatch({
        type: LOAD_COMPONENT_TYPE,
        payload: data.data
      });
    }
  }).catch(function (error) {
    showErrorToaster(error, "Unknown Error in retrieving component type", "Please refer the console logs for more details on the error.");
  });
};
